<template>
	<div>
		<div class="flex-row-align-center">
			<el-tooltip class="item" effect="dark" :content="+row.materialType === 1 ? '播放视频' : '查看图片'" placement="top" :open-delay="300">
				<div class="videoCover mr-8" @click="handleVideoClick">
					<el-image
						ref="image"
						style="width: 32px; height: 40px"
						fit="cover"
						class="radius-4"
						:preview-src-list="row.materialType === 2 ? [row.coverUrl] : []"
						:src="row.coverUrl + '?x-oss-process=image/resize,l_100'"
					>
						<template v-slot:placeholder>
							<img class="img-status" style="width: 32px; height: 40px" src="@/assets/public/video-empty.png" alt="" />
						</template>
						<template v-slot:error>
							<img class="img-status" style="width: 32px; height: 40px" src="@/assets/public/video-empty.png" alt="" />
						</template>
					</el-image>
					<img class="library-local-play" src="@/assets/public/video-play.png" v-if="+row.materialType === 1" alt="" />
				</div>
			</el-tooltip>
			<div>
				<div class="flex-row-align-center localListEdit">
					<RdShopInfo
						textType="title"
						cursor="pointer"
						:shopInfo="{ name: row.title }"
						:showShopIcon="false"
						:textWidth="160"
						:textClickCb="handleVideoClick"
					></RdShopInfo>
					<el-popover placement="right" width="400" trigger="manual" v-model="editTitleVisible">
						<div class="p-12">
							<el-input v-model="editTitle" placeholder="请输入素材标题" maxlength="50" show-word-limit></el-input>
							<div class="flex-row flex-just-end mt-20">
								<el-button @click="editTitleVisible = false">取消</el-button>
								<el-button @click="handleEditTitle" type="primary" :disabled="!editTitle">确认</el-button>
							</div>
						</div>
						<i
							slot="reference"
							@click="handleShowEditTitle"
							class="el-icon-edit-outline yx-color-primary"
							:class="{ 'table-class': row.visible && $auth.hasPermi('edit:local-material') }"
						></i>
					</el-popover>
				</div>
				<div class="font-h6-regular color-gy-7">ID: {{ row.id }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import { updateMaterialTitle } from '@/api/contentLibray.js';
export default {
	props: {
		row: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			editTitleVisible: false,
			editTitle: '',
		};
	},
	methods: {
		async handleVideoClick() {
			if (this.row.materialType === 1) {
				this.$emit('play', this.row.id);
			} else {
				this.$refs.image.clickHandler();
			}
		},
		async handleEditTitle() {
			const params = {
				id: this.row.id,
				title: this.editTitle,
			};
			await updateMaterialTitle(params);
			this.$set(this.row, 'title', this.editTitle);
			this.editTitleVisible = false;
		},
		handleShowEditTitle() {
			this.editTitleVisible = true;
			this.editTitle = this.row.title;
		},
	},
};
</script>
<style lang="less" scoped>
.videoCover {
	border-radius: 4px;
	overflow: hidden;
	position: relative;
	cursor: pointer;
	width: 32px;
	height: 40px;

	/deep/ .img-status {
		width: 32px;
		height: 40px;
		object-fit: scale-down;
	}
	.library-local-play {
		position: absolute;
		width: 14px;
		height: 14px;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}
}
.localListEdit {
	i {
		color: @color-gy7;
		font-size: 14px;
		margin-left: 4px;
		cursor: pointer;
	}
	::v-deep.hide {
		visibility: hidden;
	}
	&:hover {
		::v-deep.hide {
			visibility: visible;
		}
	}
}
i.el-icon-edit-outline {
	visibility: hidden;
	&.table-class {
		visibility: visible;
	}
}
</style>
